import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { UIRouterModule } from '@uirouter/angular';

import { CoreWidgetsModule } from '../../widgets/core.widgets.module';
import { CoreFiltersModule } from '../../core/core.filters.module';

import { BuildBrowseComponent } from './browse/browse.component';
import { BuildDetailComponent } from './detail/detail.component';
import { BuildService } from './build.service';
import { BuildResolvesService } from './build-resolves.service';

import { BUILD_STATES } from './build.modules.routes';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        CoreWidgetsModule,
        CoreFiltersModule,
        UIRouterModule.forChild({
            states: BUILD_STATES
        })
    ],
    providers: [
        BuildService,
        BuildResolvesService,
    ],
    declarations: [
        BuildBrowseComponent,
        BuildDetailComponent,
    ],
})
export class BuildModule {
    constructor() { }
}